import { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { GetAppIcon } from '@breathelife/mui';

import { Button } from '../../../../Components/Button/Button';
import { useDispatch } from '../../../../Hooks';
import { notificationSlice } from '../../../../ReduxStore/Notification/NotificationSlice';
import { getQuestionnaireSchema } from '../../../../Services/QuestionnaireSchemasService';
import { downloadFileFromBlob } from '@breathelife/file-helpers';

type Props = {
  id: string;
  version: string;
};

export function DownloadQuestionnaireSchemaButton({ id, version }: Props): ReactElement {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleQuestionnaireSchemaDownload = useCallback(async () => {
    try {
      if (!id) {
        throw Error('There is no questionnaire version id to generate a schema');
      }

      const schema = await getQuestionnaireSchema(id);

      const dataToString = JSON.stringify(schema, null, 4);
      const dataBlob = new Blob([dataToString], { type: 'application/json' });
      downloadFileFromBlob(
        dataBlob,
        `BL_questionnaire_schema_questionnaire_version_${version.replace(/\./g, '_')}.json`,
      );
    } catch (error: any) {
      dispatch(
        notificationSlice.actions.setError({
          message: t('notifications.failedToFetchEntity', {
            entity: t('admin.questionnaireManagement.table.questionnaireSchema'),
          }),
        }),
      );
    }
  }, [id, version, dispatch, t]);

  return (
    <Button
      onClick={(event) => {
        event.stopPropagation();
        void handleQuestionnaireSchemaDownload();
      }}
    >
      <GetAppIcon />
    </Button>
  );
}
